import React, { useContext } from 'react';
import { Grid } from 'semantic-ui-react';

import { VirtualizedTableColumnKey } from 'services/virtualizedTable/types';
import ActiveTableRowsCountValue from 'components/ActiveTableRowsCountValue';

import { VirtualizedTableContextProviderValue } from '../../types';
import VirtualizedTableContext from '../VirtualizedTableContext';
import VirtualizedTableItemValueField from '../VirtualizedTableItemValueField';
import VirtualizedTableColumnLabel from '../VirtualizedTableColumnLabel';

interface Props {
    columnKey?: VirtualizedTableColumnKey | undefined;
}

export const VirtualizedTableBulkEditFormValueFieldComponent = (
    props: Props
): React.ReactElement => {
    const { labelPlural }: VirtualizedTableContextProviderValue = useContext(
        VirtualizedTableContext
    );

    const { columnKey } = props;

    return (
        <React.Fragment>
            <VirtualizedTableItemValueField
                columnKey={columnKey}
                ignoreFormFormatting
            />
            {columnKey && (
                <Grid.Column width={16}>
                    <p>
                        Replace &quot;
                        <VirtualizedTableColumnLabel columnKey={columnKey} />
                        &quot; of <ActiveTableRowsCountValue /> {labelPlural}
                    </p>
                </Grid.Column>
            )}
        </React.Fragment>
    );
};

export default VirtualizedTableBulkEditFormValueFieldComponent;
